  // Cart Preview Popup elemnt JS
    var opendPopupEl = null;
    const mmodal = document.getElementById('custommmodal');
    const closeBtn = mmodal.querySelector('.mmodal-close');

    // Cart Preview Popup Close
    closeBtn.addEventListener('click', () => {
      opendPopupEl = null;
      mmodal.classList.remove('active');
    });

    // Cart Preview Popup Close by window
    window.addEventListener('click', (e) => {
      if (e.target === mmodal) {
        opendPopupEl = null;
        mmodal.classList.remove('active');
      }
    });

    // Cart Preview Popup open by button
    document.querySelectorAll(".btn--preview").forEach(previewEl => {
        previewEl.addEventListener("click", function (event) {
            event.preventDefault();
            const productBox = previewEl.closest('.listing-products-boxes');
            opendPopupEl = productBox;
            mmodal.querySelector(".cartData").innerHTML = cartHeader + productBox.querySelector(".cosma-selected_items_bag").innerHTML;
            mmodal.classList.add('active');
            removeCartItem_fn();
           
        });
    });


    // quantity changer button Plus and minus
    document.querySelectorAll(".quantity-cs").forEach(quantityEl => {
        const $parent = quantityEl.closest(".listing-products-boxes");
        const input = quantityEl.querySelector(".qty-input-cs");
       
       
        const minus = quantityEl.querySelector(".minus-cs");
        const plus = quantityEl.querySelector(".plus-cs");

        // Increase value
        plus.addEventListener("click", () => {
            var inputMinimum = Number(input.getAttribute("data-minimum")) || 1;
            var inputIncrement = Number(input.getAttribute("data-increment")) || 1;
            let value = parseInt(input.value) || 0;
            var checkvalue = value;
            var selected_variant = $parent.querySelector(".cosma-selected_variant").getAttribute("data-varid");
            if(selected_variant){
               var hasvariantAdded = $parent.querySelector(`.cosma-cart-item[data-varid="${selected_variant}"]`);
               if(hasvariantAdded){
                  var hasvariantAddedQty = Number(hasvariantAdded.getAttribute("data-qty")) || 0;
                  checkvalue = checkvalue + hasvariantAddedQty;
               }
              
            }
            var variantValidate = $parent.querySelector(".cosma-selected_variant").getAttribute("data-variant-validate");
            if(variantValidate == "false" || variantValidate == false){
                  inputMinimum =  1;
                  inputIncrement =  1;
            }
            if(checkvalue < inputMinimum){
              input.value = value + inputMinimum;
            }else{
              input.value = value + inputIncrement;
            }
        });

        // Decrease value but not below 0
        minus.addEventListener("click", () => {
            var inputMinimum = Number(input.getAttribute("data-minimum")) || 1;
            var inputIncrement = Number(input.getAttribute("data-increment")) || 1;
            let value = parseInt(input.value) || 0;
            var checkvalue = value;
            var selected_variant = $parent.querySelector(".cosma-selected_variant").getAttribute("data-varid");
            if(selected_variant){
             
              var hasvariantAdded = $parent.querySelector(`.cosma-cart-item[data-varid="${selected_variant}"]`);
               if(hasvariantAdded){
                  var hasvariantAddedQty = Number(hasvariantAdded.getAttribute("data-qty")) || 0;
                  checkvalue = checkvalue + hasvariantAddedQty;
               }
                
            }
            var variantValidate = $parent.querySelector(".cosma-selected_variant").getAttribute("data-variant-validate");
            if(variantValidate == "false" || variantValidate == false){
                  inputMinimum =  1;
                  inputIncrement =  1;
            }
            if (value > 0 && checkvalue > 0) {
                if(checkvalue <= inputMinimum){
                  input.value = value - inputMinimum;
                }else{
                  input.value = value - inputIncrement;
                }
            }
        });
     });



 // swatches change button click change selected variant and price
const variantButtons = document.querySelectorAll('.variant-swt-btn');

variantButtons.forEach(btn => {
  btn.addEventListener('click', () => {

    //  Find the closest .variant-listing-cs
    const productBox = btn.closest('.listing-products-boxes');
    const priceBox = productBox.querySelector('.cosma-listing-price span');
   
    const variantBox = btn.closest('.variant-listing-cs');
    if (!variantBox) return;

    //  Remove .active-variant-cs from all buttons in this block
    variantBox.querySelectorAll('.variant-swt-btn').forEach(b => {
      b.classList.remove('active-variant-cs');
    });

    //  Add .active-variant-cs to the clicked one
    btn.classList.add('active-variant-cs');

    //  Find the parent container (e.g. .listing-products-boxes)
    const parentBox = btn.closest('.listing-products-boxes');
    if (!parentBox) return;

    //  Collect all active variant texts inside this box
    const activeTexts = Array.from(
      parentBox.querySelectorAll('.variant-listing-cs .active-variant-cs')
    ).map(el => el.textContent.trim());

    const activeVariantString = activeTexts.join(' / ');
    // console.log(activeVariantString);

    //  Find .thisvariant inside the same box
    const variantDataBox = parentBox.querySelector('.thisvariant');
    if (!variantDataBox) return;

    //  Match span with [data-variant-title="..."]
    const matchEl = variantDataBox.querySelector(
      `[data-variant-title="${activeVariantString}"]`
    );

    if (matchEl) {
       priceBox.innerHTML = matchEl.dataset.variantPricehtml;
       parentBox.querySelector('.cosma-selected_variant').setAttribute("data-varid",matchEl.dataset.variantId);
       parentBox.querySelector('.cosma-selected_variant').setAttribute("data-varprice",matchEl.dataset.variantPrice);
       parentBox.querySelector('.cosma-selected_variant').setAttribute("data-vartitle",matchEl.dataset.variantFulltitle);
       parentBox.querySelector('.cosma-selected_variant').setAttribute("data-variant-validate",matchEl.dataset.variantValidate);
       parentBox.querySelector('.qty-alert-info').setAttribute("data-variant-validate",matchEl.dataset.variantValidate);
       parentBox.querySelector(".qty-input-cs").value = 0; // input reset
     // console.log("Matched variant:", matchEl.dataset.variantId, matchEl.dataset.variantTitle);
    } 

  });
});




// each product add bag click and add items in the list
var allbagsbutton = document.querySelectorAll(".btn--addbag");
allbagsbutton.forEach(btn => {
  btn.addEventListener("click", function (event) {
    event.preventDefault();

    const parent = this.closest(".listing-products-boxes");
    if (!parent) return;

    const qtyInput = parent.querySelector(".qty-input-cs");
    const qty = parseInt(qtyInput?.value) || 0;

    if (qty > 0) {
      const variantEl = parent.querySelector(".cosma-selected_variant");
      if (!variantEl) return;

      const varId = variantEl.getAttribute("data-varid");
      const varTitle = variantEl.getAttribute("data-vartitle");
      const varPriceCents = parseFloat(variantEl.getAttribute("data-varprice")) || 0;
      const price = (varPriceCents / 100) * qty; // Convert cents to normal price

      const cartContainer = parent.querySelector(".cosma-selected_items_bag");
      if (!cartContainer) return;

      // Check if this variant already exists in the cart
      let existingItem = cartContainer.querySelector(`.cosma-cart-item[data-varid="${varId}"]`);

      if (existingItem) {
        // Update existing item quantity and price
        const existingQty = parseInt(existingItem.getAttribute("data-qty")) || 0;
        const newQty = existingQty + qty;
        const newTotalPrice = (varPriceCents / 100) * newQty;

        existingItem.setAttribute("data-qty", newQty);
        existingItem.querySelector(".cart-item-qty").textContent = `${newQty}`;
        existingItem.querySelector(".cart-item-price").textContent = `$${newTotalPrice.toFixed(2)}`;
      } else {
        // Create new cart item
        const itemDiv = document.createElement("div");
        itemDiv.className = "cosma-cart-item";
        itemDiv.setAttribute("data-varid", varId);
        itemDiv.setAttribute("data-vartitle", varTitle);
        itemDiv.setAttribute("data-varprice", varPriceCents);
        itemDiv.setAttribute("data-qty", qty);

        itemDiv.innerHTML = `
          <div class="cart-item-title">${varTitle}</div>
          <div class="cart-item-qty">${qty}</div>
          <div class="cart-item-price">$${price.toFixed(2)}</div>
          <div class="cart-item-action"><a href="javascript:void(0)" class="btn-removeItem">${remove_icon}</a></div>
        `;

        cartContainer.appendChild(itemDiv);
      }
      qtyInput.value = 0;
      updatePreviewQty(parent);
    //  allbagsbutton.forEach(btnel => btnel.classList.remove("active"));
      btn.classList.add("active");
    }
  });
});


function removeCartItem_fn(){
  document.querySelectorAll('.btn-removeItem').forEach(btn => {
    btn.addEventListener('click', function() {
      // Find the closest cart item
      const cartItem = this.closest('.cosma-cart-item');
      if (!cartItem) return;

      // Get the variant ID
      const varId = cartItem.getAttribute('data-varid');
      if (!varId) return;

      // Find all cart items with same variant ID
      const allSameItems = document.querySelectorAll(`.cosma-cart-item[data-varid="${varId}"]`);

      // Remove all those elements
      allSameItems.forEach(item => item.remove());
      if(opendPopupEl){
        if(!opendPopupEl.querySelector(".cosma-cart-item")){
          opendPopupEl.querySelector(".btn--addbag").classList.remove("active");
        }
        
          updatePreviewQty(opendPopupEl);
      }
       
    });
  });
}

// main add to cart button will add allitems in cart
document.querySelectorAll(".btn-main_atc").forEach(btn => {
  btn.addEventListener("click", function() {
    // find parent container
    const allSections = document.querySelectorAll(".cosma-listing-content");
    if (!allSections) return;
    // prepare items array
    var items = [];
    allSections.forEach($parent => {
        // find all cart items inside
        const cartHeading = $parent.querySelector(".cosma-main-heading").textContent;
        const cartItems = $parent.querySelectorAll(".cosma-cart-item");
        if (!cartItems.length) return;

      

        cartItems.forEach(el => {
          const variantId = el.getAttribute("data-varid");
          const qty = parseInt(el.getAttribute("data-qty")) || 0;

          if (variantId && qty > 0) {
            items.push({
              id: variantId,
              quantity: qty,
              properties: { Menu: "Corporate" , Menutitle:cartHeading }
            });
          }
        });
     });
    if (items.length == 0) return;
    btn.classList.add("is--loading");
    btn.setAttribute("disabled", "true");
    // send to Shopify
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({ items })
    })
      .then(res => res.json())
      .then(data => {
        console.log("data adding to cart:", data);
        // Optionally redirect:
         window.location.href = "/checkout";
      })
      .catch(err => {
        btn.classList.remove("is--loading");
        btn.removeAttribute("disabled");

        console.error("Error adding to cart:", err);
      });
  });
});



function updatePreviewQty(boxEl){
      // Default total quantity = 0
      let totalQty = 0;
      boxEl.querySelector(".qty-input-cs").value = 0; // input reset
      // Find all cart items inside the popup
     
      const cartItems = boxEl.querySelectorAll(".cosma-cart-item");

      // Loop through each item and add up their data-qty values
      cartItems.forEach(item => {
        const qty = parseInt(item.getAttribute("data-qty")) || 0;
        totalQty += qty;
      });

      // Find the preview button span inside the popup
      const previewQtyEl = boxEl.querySelector(".btn--preview span");

      // Set the total quantity (default 0 if no items)
      if (previewQtyEl) {
        previewQtyEl.textContent = totalQty;
      }

      //calculate all item price and qunatity
       var totalitems = 0;
       var totalprice = 0;
      const allSections = document.querySelectorAll(".cosma-listing-content");
      if (allSections){
          allSections.forEach($parent => {
              // find all cart items inside
              const cartItems = $parent.querySelectorAll(".cosma-cart-item");
              if (cartItems.length){
                cartItems.forEach(el => {
                    const qty = parseInt(el.getAttribute("data-qty")) || 0;
                    var varprice = parseInt(el.getAttribute("data-varprice")) || 0;
                   
                    totalitems = totalitems + qty;
                    varprice =  (varprice / 100) * qty;
                    totalprice = totalprice + varprice;
                });
              }
            });
      }
     
      if(totalitems > 0){
          document.querySelector(".buy-btn-cs.black_btn").classList.add("active");
      }else{
          document.querySelector(".buy-btn-cs.black_btn").classList.remove("active");
      }
      var itemtext = totalitems <= 1 ? ' item' : ' items';
      document.querySelector(".cosma-cart-info-message span").innerHTML = totalitems + itemtext;
      document.querySelector(".cosma-cart-price-info").innerHTML = `$${totalprice.toFixed(2)}`;
}